export const SET_PROPRIETY_CLIENT = 'SET_PROPRIETY_CLIENT';
export const VIDER_CHAMPS = 'VIDER_CHAMPS';
export const SET_PJ = 'SET_PJ';
export const SET_LOGO = 'SET_LOGO';
export const SET_ELEMENT_ID = 'SET_ELEMENT_ID';
export const REMOVE_PJ = 'REMOVE_PJ';
export const VIDER_PJ = 'VIDER_PJ';
export const SET_CLIENT = 'SET_CLIENT';
